import React from "react";

interface GradientComponentProps {
    colors: string[];
    direction: 'to right' | 'to bottom';
    type?: 'general' | 'values' | 'frame' | 'dot';
    descs?: string[];
    labels?: string[];
    descColor?: string;
    cssClass?: string;
    cssStyle?: React.CSSProperties;
}

const GradientComponent = ({colors, direction, descs, labels, descColor, cssClass, cssStyle, type='general'}: GradientComponentProps) => {
    if (colors.length < 2) {
        return null;
    }

    const gradient= (direction === 'to right' ? direction + ', ' : '') + colors.join(', ');
    const idx = colors.findIndex(color => color === descColor);
    const align = (val: number): 'left' | 'center' | 'right' => {
        return (val - Math.floor(val)) <=0.3 ? 'left': (val - Math.floor(val)) <0.7 ? 'center' : 'right';
    }

    return (
        <div style={{width: '100%', minWidth: '16rem'}} role="progressbar" aria-label="CMA Rating" aria-valuemin={0} aria-valuemax={5} aria-valuenow={descs[0] as unknown as number}   aria-valuetext={`Rating ${descs[0]} out of 5`}>
            {descs?.length > 1 && (
                <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap', gap: '0.2rem'}}>
                    {colors.map((color, index) => (
                        <div style={{display: 'block', width: '100%'}} key={`gradient-text-${index}`}>
                            {type === 'general' && (
                                <div style={{color: 'black', border: 'none', fontSize: '0.6rem', fontWeight: '300', textAlign: 'center', height: '2rem', lineHeight: '1'}}>
                                    <span>{labels[index]}</span>
                                </div>
                            )}
                            <div style={{color: 'black', border: 'none', fontSize: '0.75rem', fontWeight: '300', textAlign: 'center'}}>
                                <span>{descs[index]}</span>
                            </div>
                            {type === 'values' && (
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '0.25rem'}}>
                                    <div style={{height: '6px', width: '6px', borderRadius: '3px', backgroundColor: color,}}></div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
            {descs?.length===1 && (
                <div style={{display: 'grid',  gridAutoFlow: 'column', gridAutoColumns: 'minmax(0, 1fr)'}}>
                    {colors.map(color => {
                        if (color === descColor) {
                            if (type === 'dot') {
                                return (
                                    <div style={{display: 'block', textAlign: 'center'}}>
                                        <div style={{color: descColor, border: 'none', opacity: '0.5', fontSize: '0.75rem', fontWeight: '300', textAlign: 'center'}}>
                                            <span>{descs[0]}</span>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '0.25rem'}}>
                                            <div style={{backgroundColor: descColor, height: '6px', width: '6px', borderRadius: '3px'}}></div>
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div style={{display: 'block', textAlign: 'center'}}>
                                    <div style={{textAlign: align(parseFloat(descs[0])), color: 'black', border: 'none', fontSize: '0.75rem', fontWeight: '300'}}>
                                        <span style={{border: '1px solid black', borderRadius: '5px', padding: '0.25rem 0.05rem 0.75rem'}}>{descs[0]}</span>
                                    </div>
                                </div>
                            );
                        } else {
                            return <div></div>;
                        }
                    })}
                </div>
            )}
            <div className={cssClass} style={{backgroundImage: `linear-gradient(${gradient})`, height: `${type === 'general' ? '1.5rem' : '0.5rem'}`, border: 'none', borderRadius: '0.25rem'}}></div>
        </div>
    );
}

export default GradientComponent;